//@ts-nocheck
import { FC, useEffect, useRef } from "react";
export async function loadBaseApp(origin: string = "") {
  if (window._baseApp) {
    return window._baseApp;
  } else {
    return Promise.all([
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.onerror = reject;
        script.onload = resolve;
        script.src = origin + "/microapps/_appMap";
        document.getElementsByTagName("head")[0].appendChild(script);
      }),
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "module";
        script.setAttribute("crossorigin", "anonymous");
        script.async = true;
        script.onerror = reject;
        script.onload = resolve;
        script.src = origin + "/microapps/public/baseBff";
        document.getElementsByTagName("head")[0].appendChild(script);
      }),
    ]).then((_) => window._baseApp);
  }
}

export async function loadMicroapps<T = any>(
  remoteAppName: string,
  shareModule: string
) {
  return await loadBaseApp().then((baseApp) =>
    baseApp.loadMicroapps<T>(remoteAppName, shareModule)
  );
}

export const OpenBoxCard: FC<any> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const setStateFn_ref = useRef((newState) => {
    return newState;
  });
  useEffect(() => {
    console.log(1);
    const app = loadMicroapps("@microapps/open-box-card", "./share").then(
      ({ vueApp, binds }) => {
        console.log(12);
        vueApp.mount(ref.current!);
        setStateFn_ref.current = binds.setState;
        setStateFn_ref.current(props);
        return vueApp;
      }
    );
    return () => {
      console.log(12);
      //  app.then(vueApp => vueApp.unmount());
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setStateFn_ref.current(props);
    }, 500);
  }, [
    props.isLogin,
    props.showOpenBoxCard,
    props.isPrimeBoxShow,
    props.boxCardData,
  ]);
  return <div ref={ref}></div>;
};
